import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import classNames from "classnames"
import Button from "common/components/Button/Button"
import convertirDocumentoRedirect from "features/Crear/pages/FormCreacionDocumento/hooks/ConvertirDocumento/ConvertirDocumento"
import { getDocumentoActions } from "features/Documentos/constants"
import { showDownloadDocumentoModal } from "features/Documentos/redux/documentosSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useUsuarioByCurrent } from "hooks/useUsuarioByCurrent"
import { TieredMenu } from "primereact/tieredmenu"
import { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { globalSelector } from "routes/globalSlice"
import "./documentosActionsStyle.css"
import GenerateDocumentoModal from "./modals/GeneratateDocumentoModal"

const DocumentosActions = ({
  rowData,
  tipoDocumento,
  tabSelected,
  typeDocumentTable,
}: $TSMigrationFixMe) => {
  const history = useHistory()
  const { formasPago, tiposImpuestosGenerales } = useSelector(globalSelector)
  const { activeCompany } = useUsuarioEmpresaActiva()
  const { usuarioByCurrent } = useUsuarioByCurrent()

  const empresaActiva = usuarioByCurrent?.empresaActiva

  const fieldValue = {
    id: activeCompany.id,
    logo: activeCompany.logo,
    logoAsBase64: activeCompany.logoAsBase64,
    ...(empresaActiva !== undefined && { ...empresaActiva }),
  }

  const { t } = useTranslation()
  const { isDocumentoRecibido } = rowData
  const [showModalGenerateDocumento, setShowModalGenerateDocumento] =
    useState(false)
  const dispatch = useDispatch()

  const refMenu = useRef()

  const isFacturaValidate = isDocumentoRecibido && tipoDocumento === 3

  const isDocumentoVenta = tabSelected === 0

  const handleConvertirDocumentoNew = async (finalType: $TSMigrationFixMe) => {
    try {
      await convertirDocumentoRedirect({
        initialType: rowData.tipoDocumento,
        finalType,
        documentoId: rowData.id,
        fieldValue,
        push: history.push,
        formasPago,
        tiposImpuestosGenerales,
      })
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error al convertir el documento:", error)
    }
  }

  const onConvertDocument = (
    e: $TSMigrationFixMe,
    route: $TSMigrationFixMe
  ) => {
    const event = e.originalEvent || e
    event.stopPropagation()
    handleConvertirDocumentoNew(route)
  }

  const onDownloadDocument = (e: $TSMigrationFixMe) => {
    const event = e.originalEvent || e
    event.stopPropagation()
    dispatch(showDownloadDocumentoModal(rowData))
  }

  const onOpenMenu = (event: $TSMigrationFixMe) => {
    event.stopPropagation()
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    refMenu.current.toggle(event)
  }

  const documentoActionsTemplate = getDocumentoActions(
    t,
    typeDocumentTable,
    isDocumentoVenta,
    onDownloadDocument,
    onConvertDocument
  )

  const showSingleAction =
    documentoActionsTemplate.length === 1 &&
    !documentoActionsTemplate[0].items?.length &&
    window.innerWidth <= 575

  return (
    <div className='documentos-actions tw-w-fit tw-flex tw-shadow-md'>
      <Button
        className={classNames("text icon dark", {
          "": isDocumentoRecibido,
        })}
        onClick={
          showSingleAction ? documentoActionsTemplate[0].command : onOpenMenu
        }
        aria-haspopup
        aria-controls={`menu-download-${rowData?.id}`}
      >
        <FontAwesomeIcon
          icon={[
            "fal",
            // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'IconName'...
            showSingleAction ? documentoActionsTemplate[0].icon : "ellipsis-v",
          ]}
          className='menu-icon'
        />
      </Button>
      {/* @ts-expect-error TS(2769): No overload matches this call. */}
      <TieredMenu
        style={{ width: "400px" }}
        className='documentos-actions__submenu'
        model={documentoActionsTemplate}
        ref={refMenu}
        id={`menu-download-${rowData?.id}`}
        popup
      />
      {!isFacturaValidate && (
        <GenerateDocumentoModal
          onHide={() => setShowModalGenerateDocumento(false)}
          visible={showModalGenerateDocumento}
          tipoDocumento={tipoDocumento}
        />
      )}
    </div>
  )
}
export default DocumentosActions
